"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeCatching = void 0;
const merging_1 = require("./merging");
function mergeCatching(callback, ...items) {
    return (0, merging_1.mergeIterators)(callback, ...(0, merging_1.getIterators)([this, ...items]));
}
exports.mergeCatching = mergeCatching;
